import { toast } from "react-toastify";
import {
  deleteDataFromApi,
  getDataFromApi,
  postDataFromApi,
  putDataFromApi,
} from "../../../../../services/commonServices";
import {
  purchaseOrderDeleteApi,
  purchaseOrderUpdateApi,
  purchaseOrderCreateApi,
  purchaseOrderGet_Api,
  purchaseOrderDownload,
  updatePOInsuranceApi,
  createPOInsuranceApi,
  deletePOInsuranceApi,
  getPOInsuranceBYPRDIDApi,
  vendorRatingCreateApi,
  vendorRatingUpdateApi,
  purchaseOrderDownloadItems,
} from "../../../../../services/api";
import {
  getFormatedDate,
  getUserDetails,
} from "../../../../../services/commonFunction";
import { encryptDataForURL } from "../../../../../utills/useCryptoUtils";
import { handleCommonUndoLastChanges } from "../../UndoApprovalRequestHandler";
const recievedStatus = [
  {
    label: "Received",
    value: "received",
  },
  {
    label: "Partially Received",
    value: "partially_received",
  },
  {
    label: "Not Received",
    value: "not_received",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
];

export const handleGetPurchaseOrder = async (
  EditRecordId,
  setFormData,
  setTableData,
  viewOnly,
  status,
  POItemId,
) => {
  let getApi = purchaseOrderGet_Api(EditRecordId);
  let res = await getDataFromApi(getApi);

  if (res?.data?.status === 200) {
    if (res.data.data.po_terms_conditions === null) {
      delete res.data.data.po_terms_conditions;
    }

    setFormData((prevFormData) => {
      let updatedFormData = {};
      !POItemId &&
        res.data.data.items.forEach((item, i) => {
          updatedFormData["prd_id_" + i] = item.prd_id;
          updatedFormData["prd_item_code_" + i] = item.fk_item_id;
          updatedFormData["prd_item_code_text_" + i] =
            item?.item_details?.item_rm_code;
          updatedFormData["prd_item_description_" + i] =
            item.prd_item_description;
          updatedFormData["prd_quantity_" + i] = item.prd_quantity;
          updatedFormData["prd_uom_" + i] = item.prd_uom;
          updatedFormData["prd_manufacture_time_" + i] =
            item.prd_manufacture_time;
          updatedFormData["prd_make_" + i] = item.prd_make;
          updatedFormData["prd_tech_specification_" + i] =
            item.prd_tech_specification;
          updatedFormData["prd_avg_monthly_consumption_" + i] =
            item.prd_avg_monthly_consumption;
          updatedFormData["prd_buffer_stock_" + i] = item.prd_buffer_stock;
          updatedFormData["prd_closing_stock_" + i] = item.prd_closing_stock;
          updatedFormData["prd_consumption_per_day_" + i] =
            item.prd_consumption_per_day;
          updatedFormData["prd_available_stock_days_" + i] =
            item.prd_available_stock_days;
          updatedFormData["prd_requested_delivery_date_" + i] =
            item.prd_requested_delivery_date;
          updatedFormData["prd_remark_" + i] = item.prd_remark;
          updatedFormData["prd_unit_price_" + i] = item.prd_unit_price;
          updatedFormData["prd_price_" + i] = item.prd_price;
          updatedFormData["prd_discount_" + i] = item.prd_discount;
          updatedFormData["prd_total_" + i] = item.prd_total;
          updatedFormData["prd_miscellaneous_items_" + i] =
            item?.prd_miscellaneous_item;
          // updatedFormData["prd_additional_remark_" + i] = item?.prd_addtional_remark;
          updatedFormData["prd_additional_remark_" + i] = item?.prd_addtional_remark;

          updatedFormData["prd_specification_" + i] =
            item?.prd_item_specifications;
          if (item.prd_insurance_json) {
            Object.entries(item.prd_insurance_json).forEach(([key, value]) => {
              updatedFormData[key + "_" + i] = value;
            });
          }
          updatedFormData["prd_item_status_" + i] = recievedStatus.find(
            (st) => st.value === item?.prd_item_status,
          )?.label;
          updatedFormData["prd_received_quantity_" + i] =
            item?.prd_received_quantity;
          updatedFormData["prd_date_of_receipt_" + i] =
            item?.prd_date_of_receipt;
          updatedFormData["prd_expiry_date_" + i] = item?.prd_expiry_date;
          updatedFormData["prd_remark_" + i] = item?.prd_remark;
          updatedFormData["prd_is_pre_closed_" + i] = item?.prd_is_pre_closed;
          updatedFormData["fk_po_id_" + i] = item?.fk_po_id;
          updatedFormData["prd_pending_quantity_" + i] = getPendingQty(
            item.prd_quantity,
            item?.prd_received_quantity,
          );
        });
      if (
        ["Approved", "Closed", "Pre-Close"].includes(res.data.data.po_status) &&
        res.data.data.po_received_qty
      ) {
        res.data.data.show_vendor_rating = ["Show"];
      }
      const data = res?.data?.data?.requisition_details;
      const typeDev = {
        1: "Consumable",
        2: "Non-Consumable",
      };
      let singleItemDetails = {};
      if (POItemId) {
        singleItemDetails = res.data.data.items.find(
          (item) => item.prd_id === parseInt(POItemId),
        );
        singleItemDetails.prd_item_code_text =
          singleItemDetails?.item_details?.item_rm_code;
      }
      const vendorRationDetails = res?.data?.data?.vendor_rating_details
      return {
        0: {
          ...prevFormData[0],
          ...res?.data?.data,
          vr_id: vendorRationDetails?.vr_id,
          po_vendor_id: vendorRationDetails?.vr_po_vendor_id,
          po_vendor_name:
            vendorRationDetails?.vr_po_vendor_name,
          po_vendor_type:
            vendorRationDetails?.vr_po_vendor_type,
          po_qty_ordered:
            vendorRationDetails?.vr_po_qty_ordered,
          po_qty_accepted:
            vendorRationDetails?.vr_po_qty_accepted,
          po_qty_accepted_under_deviation:
            vendorRationDetails
              ?.vr_po_qty_accepted_under_deviation,
          po_qty_rejected:
            vendorRationDetails?.vr_po_qty_rejected,
          po_delivery_days:
            vendorRationDetails?.vr_po_delivery_days,
          po_item_rcv_date:
            vendorRationDetails?.vr_po_item_rcv_date,
          po_item_targeted_date:
            vendorRationDetails?.vr_po_item_targeted_date,
          po_quality_rating:
            vendorRationDetails?.vr_po_quality_rating,
          po_delivery_rating:
            vendorRationDetails?.vr_po_delivery_rating,
          po_cost_rating_per:
            vendorRationDetails?.vr_po_cost_rating_per,
          po_discount_per:
            vendorRationDetails?.vr_po_discount_per,
          po_comm_resp_rating: getRatingValue(
            vendorRationDetails?.vr_po_comm_resp_rating,
            1,
          ),
          po_stock_avail_rating: getRatingValue(
            vendorRationDetails?.vr_po_stock_avail_rating,
            1,
          ),
          po_vendor_rating:
            vendorRationDetails?.vr_po_vendor_rating,
          po_final_vendor_rating:
            vendorRationDetails?.vr_po_final_vendor_rating,
          po_vendor_remark:
            vendorRationDetails?.vr_po_vendor_remark,
          ...data,
          ...singleItemDetails,
          req_id: data.req_id,
          req_status: data.req_status,
          fk_pr_companyid: data?.company_details?.cmp_name,
          fk_branchid: `${data?.fk_branchid}`,
          fk_branchid_name: `${data?.branch_details?.br_name} (${data?.branch_details?.br_code})`,
          fk_departmentid: data?.department_details?.dept_name,
          req_no: data.req_no,
          req_date: data.req_date,
          req_expected_delivery_date: data.req_expected_delivery_date,
          req_type: data.req_type,
          req_remark: data.req_remark,
          request_no: data.req_no,
          type: typeDev[data.req_type],
          req_approved_by: data?.req_approved_by_details
            ? data?.req_approved_by_details?.first_name +
            " " +
            data?.req_approved_by_details?.last_name +
            "(" +
            data?.req_approved_by_details?.usr_emp_id_orig +
            ")"
            : "",
          req_created_by_name: data?.req_created_by_details
            ? data?.req_created_by_details?.first_name +
            " " +
            data?.req_created_by_details?.last_name +
            "(" +
            data?.req_created_by_details?.usr_emp_id_orig +
            ")"
            : "",
          po_no: res.data.data?.po_number,
          po_billing_address: data?.branch_details?.br_address,
          po_date: res.data.data?.po_date,
          po_gst_no: res.data.data?.po_gst_no,
          po_ship_to:
            status === "View"
              ? res.data.data?.po_ship_to_details?.cmp_name
              : res.data.data?.po_ship_to,
          // po_to: res.data.data?.po_to,
          po_category: res.data.data?.po_category,
          fk_supplier_id:
            status === "View"
              ? res.data.data?.supplier_details?.sup_name
              : res.data.data?.fk_supplier_id,
          po_quotation_no: res.data.data?.po_quotation_no,
          po_quotation_date: res.data.data?.po_quotation_date,
          po_req_no: res.data.data?.po_req_no,
          po_requisition_date: res?.data?.data?.po_requisition_date
            .split("-")
            .reverse()
            .join("/"),
          fk_req_id: res?.data?.data?.fk_req_id,
          po_gst_type: res?.data?.data?.po_gst_type,
          po_ship_address:
            res.data.data?.po_ship_address || data?.branch_details?.br_address,
          // po_delivery_address: res.data.data?.po_delivery_address,
          po_delivery_date: res.data.data?.po_delivery_date,
          po_item_rcv_date: res.data.data.items.reduce((max, item) => {
            const current = item.prd_date_of_receipt
              ? new Date(item.prd_date_of_receipt)
              : null;

            if (!current) return max;
            if (!max || current > max) return current;

            return max;
          }, null),
          po_vendor_type: [
            ...new Set(
              res?.data?.data?.items
                ?.map(
                  (item) => item?.item_details?.category_details?.category_name,
                )
                ?.filter(Boolean) || [],
            ),
          ].join(", "),
          po_payment_term: res.data.data?.po_payment_term,
          po_credit_limit: res.data.data?.supplier_details?.sup_credit_limit,
          po_approved_by: res.data.data?.approval_details
            ? res.data.data?.approval_details?.first_name +
            " " +
            res.data.data?.approval_details?.last_name +
            "(" +
            res.data.data?.approval_details?.usr_emp_id_orig +
            ")"
            : "",
          po_created_by_name: res.data.data?.created_by_details
            ? res.data.data?.created_by_details?.first_name +
            " " +
            res.data.data?.created_by_details?.last_name +
            "(" +
            res.data.data?.created_by_details?.usr_emp_id_orig +
            ")"
            : "",
          // po_manufacture_time: res.data.data?.po_manufacture_time,

          // po_payment_term:
          // res?.data?.data?.po_payment_term === "advance" ? "Advance" :
          //     res?.data?.data?.po_payment_term === "partially_advance" ? "Partially Advance" :
          //         res?.data?.data?.po_payment_term === "credit_1_15" ? "1-15 Days Credit" :
          //             res?.data?.data?.po_payment_term === "credit_15_30" ? "15-30 Days Credit" :
          //                 res?.data?.data?.po_payment_term === "credit_30_45" ? "30-45 Days Credit" :
          //                     res?.data?.data?.po_payment_term === "credit_45_60" ? "45-60 Days Credit" :
          //                         res?.data?.data?.po_payment_term === "against_proforma_invoice" ? "Against Proforma Invoice" :
          //                             res?.data?.data?.po_payment_term
          //                                 "",
          // fk_supplier_id: viewOnly ? res?.data?.data?.supplier_details?.sup_name : res?.data?.data?.fk_supplier_id
          po_cc_email: Array.isArray(res?.data?.data?.po_cc_email)
            ? res.data.data.po_cc_email
            : res?.data?.data?.po_cc_email
              ? [res.data.data.po_cc_email]
              : [],
          po_supplier_email: Array.isArray(res?.data?.data?.po_supplier_email)
            ? res.data.data.po_supplier_email
            : res?.data?.data?.po_supplier_email
              ? [res.data.data.po_supplier_email]
              : [],
        },
        1: {
          ...prevFormData[1],
          po_total_amt: res.data.data?.po_total_amount,
          po_gst: res.data.data?.po_gst_amount,
          po_total_gst: res.data.data?.po_total_gst,
          po_ship_to: res.data.data?.po_ship_to,
          fk_supplier_id: res.data.data?.fk_supplier_id,
          ...updatedFormData,
        },
      };
    });
    if (!POItemId) {
      setTableData(res.data.data.items);
    }
  } else {
    toast.error(res.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

export const handleGetPurchaseOrderTableData = async (
  formData,
  setFormData,
  i,
) => {
  // let purchaseTableDataGetApi = purchaseOrderGetApi(formData.prd_id);

  // let res = await getDataFromApi(purchaseTableDataGetApi)
  let updatedFormData = {};
  // let item = res?.data?.data
  // updatedFormData["prd_id_" + i] = item.prd_id;
  // updatedFormData["prd_item_code_" + i] = item?.fk_item_id;
  // updatedFormData["prd_item_code_text_" + i] = item?.item_details?.item_rm_code;
  // updatedFormData["prd_item_description_" + i] = item.prd_item_description;
  // updatedFormData["prd_quantity_" + i] = item.prd_quantity;
  // updatedFormData["prd_uom_" + i] = item.prd_uom;
  // updatedFormData["prd_make_" + i] = item.prd_make;
  // updatedFormData["prd_manufacturing_time_" + i] = item.prd_manufacture_time;
  // updatedFormData["prd_tech_specification_" + i] = item.prd_tech_specification;
  // updatedFormData["prd_avg_monthly_consumption_" + i] = item.prd_avg_monthly_consumption;
  // updatedFormData["prd_buffer_stock_" + i] = item.prd_buffer_stock;
  // updatedFormData["prd_closing_stock_" + i] = item.prd_closing_stock;
  // updatedFormData["prd_consumption_per_day_" + i] = item.prd_consumption_per_day;
  // updatedFormData["prd_available_stock_days_" + i] = item.prd_available_stock_days;
  // updatedFormData["prd_requested_delivery_date_" + i] = item.prd_requested_delivery_date;
  // updatedFormData["prd_remark_" + i] = item.prd_remark;
  // updatedFormData["prd_unit_price_" + i] = item.prd_unit_price;
  // updatedFormData["prd_price_" + i] = item.prd_price;
  // updatedFormData["prd_discount_" + i] = item.prd_discount;
  // updatedFormData["prd_total_" + i] = item.prd_total;
  // updatedFormData["prd_miscellanous_items_" + i] = item?.prd_miscellanous_items;
  // updatedFormData["prd_additional_remark_" + i] = item?.prd_additional_remark;
  // updatedFormData["prd_specification_" + i] = item?.prd_specification;
  // if (res.data.status === 200) {
  //     setFormData((prevFormData) => {
  //         const updatedData = {
  //             ...prevFormData,
  //             0: {
  //                 ...prevFormData[0],

  //             },
  //             1: {
  //                 ...prevFormData[1],
  //                 ...updatedFormData,

  //             }
  //         };

  //         return updatedData;
  //     });
  // }
  // else {
  //     toast.error(res.message, {
  //         position: "top-right",
  //         autoClose: 2000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "light",
  //     });
  // }
};
export const handlePurchaseOrderCreateUpdate = async (
  formData,
  handleSubmit,
  setIsOverlayLoader,
  navigate,
  status,
  setFormData,
  EditRecordId,
  setSubTableData,
  isNavigate,
  remarkText,
  isPreview,
) => {
  setIsOverlayLoader(true);
  try {
    let payloadData = {
      //   po_number: formData[0]?.po_no,
      po_billing_address: formData[0]?.po_billing_address,
      po_date: formData[0]?.po_date,
      po_gst_no: formData[0]?.po_gst_no,
      po_to: formData[0]?.po_to,
      po_ship_to: formData[0]?.po_ship_to,
      po_quotation_no: formData[0]?.po_quotation_no,
      po_quotation_date: formData[0]?.po_quotation_date,
      po_req_no: formData[0]?.po_req_no,
      po_req_date: formData[0]?.po_req_date,
      // po_payment_term: formData[0]?.po_payment_term,
      po_gst_type: formData[0]?.po_gst_type,
      po_category: formData[0]?.po_category,
      po_delivery_date: formData[0]?.po_delivery_date,
      //  po_delivery_address: formData[0]?.po_delivery_address,
      po_ship_address: formData[0]?.po_ship_address,
      fk_req_id: formData[0]?.fk_req_id,
      fk_supplier_id: formData[0]?.fk_supplier_id,
      po_total_amount: formData[1]?.po_total_amt,
      po_gst_amount: formData[1]?.po_gst,
      po_total_gst: formData[1]?.po_total_gst,
      po_terms_conditions: formData[0]?.po_terms_conditions,
      po_payment_term: formData[0]?.po_payment_term,
      // po_supplier_email: formData[0]?.po_supplier_email,
      po_cc_emails: formData[0]?.po_cc_emails,
      po_supplier_email: formData[0]?.po_supplier_email,
      fk_vr_id: formData[0]?.vr_id,
      po_bill_value: formData[0]?.po_bill_value,
      po_payment_from_ho_branch: formData[0]?.po_payment_from_ho_branch,
    };
    const statuses = {
      1: "Saved",
      2: "Posted",
      3: "Reject",
      4: "Approved",
      5: "Pre-Close",
      7: "Cancelled",
    };
    let res;
    if ([2].includes(status)) {
      payloadData.fk_approval_id = formData[0]?.fk_approval_id;
      if (!payloadData.fk_approval_id) {
        toast.error("Please select approval user", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }
    } else if ([3, 7].includes(status)) {
      payloadData.fk_supplier_id = formData[1]?.fk_supplier_id;
      payloadData.po_ship_to = formData[1]?.po_ship_to;
      payloadData.po_reject_remark = remarkText;
      // payloadData={
      //     po_reject_remark:remarkText,
      //     fk_req_id: formData[0]?.fk_req_id,
      // }
    } else if (status === 4) {
      payloadData.fk_supplier_id = formData[1]?.fk_supplier_id;
      payloadData.po_ship_to = formData[1]?.po_ship_to;
    }
    if (formData[0]?.po_id || formData[0]?.po_no) {
      const isValidate = handleSubmit();
      if (!isValidate) {
        return false;
      }

      let currentVrId = formData[0]?.vr_id;

      if ([3, 4, 5, 6, 7, 8, 9].includes(status)) {
        const vendorRatingPayload = {
          fk_po_id: formData[0]?.po_id,
          fk_supplier_id:
            Number(formData[0]?.fk_supplier_id) ||
            formData[0]?.supplier_details?.sup_id,
          vr_po_vendor_id: formData[0]?.po_vendor_id,
          vr_po_vendor_name: formData[0]?.po_vendor_name,
          vr_po_vendor_type: formData[0]?.po_vendor_type,
          vr_po_qty_ordered: formData[0]?.po_qty_ordered,
          vr_po_qty_accepted: formData[0]?.po_qty_accepted,
          vr_po_qty_accepted_under_deviation:
            formData[0]?.po_qty_accepted_under_deviation,
          vr_po_qty_rejected: formData[0]?.po_qty_rejected,
          vr_po_delivery_days: formData[0]?.po_delivery_days,
          vr_po_item_rcv_date: formData[0]?.po_item_rcv_date,
          vr_po_item_targeted_date: formData[0]?.po_item_targeted_date,
          vr_po_quality_rating: formData[0]?.po_quality_rating,
          vr_po_delivery_rating: formData[0]?.po_delivery_rating,
          vr_po_cost_rating_per: formData[0]?.po_cost_rating_per,
          vr_po_discount_per: formData[0]?.po_discount_per,
          vr_po_comm_resp_rating: getRatingValue(
            formData[0]?.po_comm_resp_rating,
          ),
          vr_po_stock_avail_rating: getRatingValue(
            formData[0]?.po_stock_avail_rating,
          ),
          vr_po_vendor_rating: Number(
            parseFloat(formData[0]?.po_vendor_rating || 0).toFixed(2),
          ),
          vr_po_final_vendor_rating: formData[0]?.po_final_vendor_rating,
          vr_po_vendor_remark: formData[0]?.po_vendor_remark,
        };

        if (currentVrId) {
          await postDataFromApi(
            vendorRatingUpdateApi(currentVrId),
            vendorRatingPayload,
          );
        } else {
          let resVendor = await postDataFromApi(
            vendorRatingCreateApi,
            vendorRatingPayload,
          );
          if (resVendor?.data?.status === 200) {
            currentVrId = resVendor.data.data.vr_id;
          }
        }
      }

      payloadData.po_id = formData[0]?.po_id;
      payloadData.po_status = statuses?.[status] || "";
      if (!payloadData.po_status) {
        delete payloadData.po_status
      }
      payloadData.fk_vr_id = currentVrId;

      if ([6].includes(status)) {
        delete payloadData.po_status;
      }
      if ([5, 6, 7].includes(status)) {
        payloadData.fk_supplier_id = formData[0]?.supplier_details?.sup_id;
        payloadData.po_ship_to = formData[0]?.po_ship_to_details?.cmp_id;
      }

      const updateApi = purchaseOrderUpdateApi(formData[0]?.po_id);
      res = await postDataFromApi(updateApi, payloadData);

      if (res?.data?.status === 200) {
        handleGetPurchaseOrder(
          res.data.data.po_id,
          setFormData,
          setSubTableData,
          "",
        );
      } else {
        toast.error(res.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      res = await postDataFromApi(purchaseOrderCreateApi, formData);
    }

    if (res?.data?.status === 200) {
      if ([2, 5, 4, 3].includes(status)) {
        handleCommonUndoLastChanges(res?.data?.message, formData[0]?.po_id, setIsOverlayLoader, navigate, "purchaseOrder", formData)
      }
      else {
        toast.success(res?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        if (isPreview) {
          navigate(
            `/purchase/purchaseForm/${encryptDataForURL(
              formData[0]?.po_id,
            )}/purchaseOrderPreview/${encryptDataForURL(formData[0]?.po_id)}`,
          );
          return;
        }
        if (isNavigate) {
          setTimeout(()=>{
            navigate("/purchase");
          },3000)
          
        }
      }
    } else {
      // toast.error(res.message, {
      //     position: "top-right",
      //     autoClose: 2000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      // });
    }
  } catch (ex) {
    // console.log("Purchase Order", ex)
  } finally {
    setIsOverlayLoader(false);
  }
};

export const handlePurchaseOrderDelete = async (
  poId,
  setIsDelete,
  getAllListingData,
  setPopupIndex,
) => {
  let deletePurchaseOrder = purchaseOrderDeleteApi(poId);
  let res = await deleteDataFromApi(deletePurchaseOrder);
  if (res?.data?.status === 200) {
    toast.success(res.data.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(res.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  setIsDelete(false);
  setPopupIndex(-1);
  getAllListingData();
};

export const handlePurchaseReqTableDataDelete = async (
  formData,
  setIsPopupOpen,
  setEditableIndex,
  indexNo,
  setFormData,
  setTableData,
) => {
  let purchaseTableDataDeleteApi = purchaseOrderDeleteApi(
    formData[1]["prd_id_" + indexNo],
  );
  let res = await deleteDataFromApi(purchaseTableDataDeleteApi);
  if (res?.data?.status === 200) {
    setIsPopupOpen("");
    setEditableIndex("");
    setFormData((prevData) => {
      let updatedFormData = {};
      let i = indexNo;
      updatedFormData["prd_id_" + i] = "";
      updatedFormData["prd_item_description_" + i] = "";
      updatedFormData["prd_quantity_" + i] = "";
      updatedFormData["prd_uom_" + i] = "";
      updatedFormData["prd_manufacture_time_" + i] = "";
      updatedFormData["prd_make_" + i] = "";
      updatedFormData["prd_tech_specification_" + i] = "";
      updatedFormData["prd_avg_monthly_consumption_" + i] = "";
      updatedFormData["prd_buffer_stock_" + i] = "";
      updatedFormData["prd_closing_stock_" + i] = "";
      updatedFormData["prd_consumption_per_day_" + i] = "";
      updatedFormData["prd_available_stock_days_" + i] = "";
      updatedFormData["prd_requested_delivery_date_" + i] = "";
      updatedFormData["prd_remark_" + i] = "";
      return {
        ...prevData,
        0: {
          ...prevData[0],
        },
        1: {
          ...prevData[1],
          ...updatedFormData,
        },
      };
    });
    handleGetPurchaseOrder(
      formData[0]?.po_no,
      setFormData,
      setTableData,
      "",
      "",
    );
    // handleGetPurchaseOrderTableData(formData[0]?.po_no, setFormData, setTableData, "", "")
    toast.success(res.data.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(res.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

export const getCalculationsForPrice = (formData, index) => {
  const unitPrice = parseFloat(formData?.[`prd_unit_price_${index}`]) || 0;
  const discount = parseFloat(formData?.[`prd_discount_${index}`]) || 0;

  const price = unitPrice * (1 - discount / 100);
  return price.toFixed(2);
};

export const getCalculationsForTotal = (formData, setFormData) => {
  if (!formData[1]) return;

  const updatedFormData = formData[1];
  const updatedTotals = {};

  Object.keys(updatedFormData).forEach((key) => {
    if (key.startsWith("prd_price_")) {
      const index = key.split("_").pop();
      const unitPrice =
        parseFloat(updatedFormData[`prd_unit_price_${index}`]) || 0;
      const quantity =
        parseFloat(updatedFormData[`prd_quantity_${index}`]) || 0;
      const price = parseFloat(updatedFormData[`prd_price_${index}`]) || 0;

      const isValid = unitPrice > 0 && quantity > 0 && price > 0;

      if (isValid) {
        const total = price * quantity;
        // total.toFixed(2)
        updatedTotals[`prd_total_${index}`] = total.toFixed(2);
      } else {
        updatedTotals[`prd_total_${index}`] = 0;
      }
    }
  });
  if (Object.keys(updatedTotals).length > 0) {
    setFormData((prev) => ({
      ...prev,
      1: {
        ...prev[1],
        ...updatedTotals,
      },
    }));
  }
};
export const getPendingQty = (value1, value2) => {
  let totalQty = parseFloat(value1) || 0;
  let rcvQty = parseFloat(value2) || 0;
  return totalQty - rcvQty || 0;
};

export const handleDownloadPO = async (poId, poNo) => {
  try {
    let res;
    let payload = {
      po_id: poId,
    };
    res = await postDataFromApi(purchaseOrderDownload, payload, "", 1);
    if (res.data.status === 200) {
      let pdfDate = "PO" + (poNo || '') + "_" + getFormatedDate(new Date(), "", 1);
      const blob = new Blob([res.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = pdfDate + ".pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } catch (err) {
    console.log("err", err);
  }
};

export const handleDownloadPOItemsExport = async (poId, poNo) => {
  try {
    let res;
    let payload = {
      po_id: poId,
    };
    const exportApi = purchaseOrderDownloadItems(poId);
    res = await getDataFromApi(exportApi, payload, "", "", 1);
    if (res.status === 200) {
      let pdfDate = "PO Items" + (poNo || '') + "_" + getFormatedDate(new Date(), "", 1);
      const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = pdfDate + ".xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } catch (err) {
    console.log("err", err);
  }
};

const getRatingValue = (val, isDecimal) => {
  if (isDecimal) {
    const ratingMap = {
      Excellent: 100,
      Good: 75,
      Fair: 50,
    };
    const numVal = Number(val);
    return (
      Object.keys(ratingMap).find((key) => ratingMap[key] === numVal) ?? "Poor"
    );
  }

  switch (val) {
    case "Excellent":
      return 100;
    case "Good":
      return 75;
    case "Fair":
      return 50;
    default:
      return 0;
  }
};
export const vendorRatingCalculation = (fieldName, formData) => {
  let calculationValue = 0;

  switch (fieldName) {
    case "po_delivery_rating": {
      let days = formData[0]?.po_delivery_days || 0;

      switch (true) {
        case days < 1:
          calculationValue = 100;
          break;
        case days < 11:
          calculationValue = 75;
          break;
        case days < 20:
          calculationValue = 50;
          break;
        case days < 30:
          calculationValue = 25;
          break;
        default:
          calculationValue = 0;
      }
      break;
    }

    case "po_cost_rating_per": {
      let discount = formData[0]?.po_discount_per || 0;
      switch (true) {
        case discount > 34:
          calculationValue = 100;
          break;
        case discount > 29:
          calculationValue = 86;
          break;
        case discount > 24:
          calculationValue = 71;
          break;
        case discount > 19:
          calculationValue = 57;
          break;
        case discount > 14:
          calculationValue = 43;
          break;
        case discount > 9:
          calculationValue = 29;
          break;
        case discount > 4:
          calculationValue = 14;
          break;
        case discount > 0:
          calculationValue = 0;
          break;
        default:
          calculationValue = 0;
      }
      break;
    }
    case "po_vendor_rating": {
      let data = formData[0] || {};

      let quality = Number(data?.po_quality_rating || 0); // K
      let delivery = Number(data?.po_delivery_rating || 0); // O
      let cost = Number(data?.po_cost_rating_per || 0); // Q

      let comm = data?.po_comm_resp_rating || ""; // R
      let stock = data?.po_stock_avail_rating || ""; // S

      calculationValue = (
        0.6 * quality +
        0.25 * delivery +
        0.05 * cost +
        0.05 * getRatingValue(comm) +
        0.05 * getRatingValue(stock)
      ).toFixed(3);

      break;
    }
    case "po_final_vendor_rating": {
      let rating = formData[0]?.po_vendor_rating || 0;

      switch (true) {
        case rating > 90:
          calculationValue = "A (Excellent)";
          break;
        case rating > 80:
          calculationValue = "B (Good)";
          break;
        case rating > 70:
          calculationValue = "C (Average)";
          break;
        default:
          calculationValue = "D (Poor/Deregister)";
      }
      break;
    }
    case "po_delivery_days": {
      const receivedDate = formData[0]?.po_item_rcv_date;
      const targetDate = formData[0]?.po_item_targeted_date;

      if (receivedDate && targetDate) {
        const rDate = new Date(receivedDate);
        const tDate = new Date(targetDate);

        // check valid dates
        if (!isNaN(rDate) && !isNaN(tDate)) {
          const diffDays = Math.ceil((rDate - tDate) / (1000 * 60 * 60 * 24));
          calculationValue = diffDays ? diffDays : 0;
        } else {
          calculationValue = 0;
        }
      } else {
        calculationValue = 0;
      }

      break;
    }
    case "po_quality_rating": {
      const accepted = Number(formData[0]?.po_qty_accepted) || 0;
      const deviation =
        Number(formData[0]?.po_qty_accepted_under_deviation) || 0;
      const rejected = Number(formData[0]?.po_qty_rejected) || 0;
      const ordered = Number(formData[0]?.po_qty_ordered) || 0;

      const value = ordered
        ? ((accepted + deviation * 0.5 + rejected * 0) * 100) / ordered
        : 0;

      calculationValue = Number(value.toFixed(2)); // optional rounding
      break;
    }
    case "po_qty_rejected": {
      const deviation =
        Number(formData[0]?.po_qty_accepted_under_deviation) || 0;
      const ordered = Number(formData[0]?.po_qty_ordered) || 0;

      const value = ordered - deviation;

      calculationValue = Number(value.toFixed(2)); // optional rounding
      break;
    }
    default:
      calculationValue = 0;
  }
  return calculationValue;
};
export const checkedEnterqtyValide = (fieldName, formData, value) => {
  if (fieldName === "po_qty_accepted_under_deviation") {
    const accepted = Number(formData[0]?.po_qty_accepted) || 0;
    const deviation = Number(value) || 0;
    if (deviation > accepted) {
      toast.error(
        "Accepted Qty under deviation should not exceed the accepted quantity.",
        {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        },
      );
      return {
        isValide: false,
        errorMsg: "Rejection quantity should not exceed the accepted quantity.",
      };
    }
    return {
      isValide: true,
      errorMsg: "",
    };
  } else if (fieldName === "po_qty_rejected") {
    const po_qty_ordered = Number(formData[0]?.po_qty_ordered) || 0;
    const po_qty_rejected = Number(value) || 0;
    if (po_qty_rejected > po_qty_ordered) {
      toast.error("Entered quantity should not exceed the total quantity.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return {
        isValide: false,
        errorMsg: "Entered quantity should not exceed the total quantity.",
      };
    }
    return {
      isValide: true,
      errorMsg: "",
    };
  }
};
export const POInsuranceCreateUpdate = async (
  actionSelected,
  editableIndex,
  tableData,
  formData,
  section,
  setSaveClicked,
  setEditableIndex,
  setPopupIndex,
  popupIndex,
  setPopupOpenAssignment,
  setIsBtnClicked,
  setIsOverlayLoader,
  setTableData,
  setFormData,
  isCustomPopup,
  setIsCustomPopup,
) => {
  if (actionSelected === "Save" || actionSelected === "customSave") {
    setIsBtnClicked(true);
    let newRowIndex = editableIndex;
    if (actionSelected === "customSave") {
      newRowIndex = tableData.length;
    }
    const type = formData[1]?.["insurance_is_burglary_" + newRowIndex];
    let payload = {
      fk_po_id: formData[0]?.po_id,
      fk_item_id: formData[0]?.fk_item_id,
      fk_prd_id: formData[0]?.prd_id,
      ins_qty: formData[1]?.["ins_qty_" + newRowIndex],
      range_spec: formData[1]?.["range_spec_" + newRowIndex],
      model_name: formData[1]?.["model_name_" + newRowIndex],
      instrument_sr_no: formData[1]?.["instrument_sr_no_" + newRowIndex],
      make: formData[1]?.["make_" + newRowIndex],
      tax_invoice_amount: formData[1]?.["tax_invoice_amount_" + newRowIndex],
      remark: formData[1]?.["remark_" + newRowIndex],
      burglary_insurance:
        type === "Burglary"
          ? formData[1]?.["burglary_insurance_" + newRowIndex] || ""
          : "",

      fire_insurance:
        type !== "Burglary"
          ? formData[1]?.["fire_insurance_" + newRowIndex] || ""
          : "",
      power_source: formData[1]?.["power_source_" + newRowIndex],
      amount_18_gst: formData[1]?.["amount_18_gst_" + newRowIndex],
      amount_28_gst: formData[1]?.["amount_28_gst_" + newRowIndex],
      insurance_due_date: formData[1]?.["insurance_due_date_" + newRowIndex],
      insurance_start_date: formData[1]?.["insurance_start_date_" + newRowIndex],
      insurance_created_by: getUserDetails()?.logged_in_user_info?.usr_id,
      insurance_is_burglary: type === "Burglary",
    };
    let nonRequiredFields = [
      "amount_18_gst",
      "amount_28_gst",
      "burglary_insurance",
      "fire_insurance",
    ];

    for (let obj in payload) {
      if (
        (payload[obj] === undefined || payload[obj] === "") &&
        !nonRequiredFields.includes(obj)
      ) {
        const fieldarr = section.rows[0].filter((field, index) => {
          if (field.name === obj) {
            field.label = section.headers[index].label;
            return true;
          }
          return false;
        });
        if (fieldarr.length > 0) {
          let errLabel = fieldarr ? fieldarr[0].label : "";
          toast.error(errLabel + " is required", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsBtnClicked(false);
          return;
        }
      }
    }

    let res;
    if (actionSelected !== "customSave") {
      res = await putDataFromApi(
        updatePOInsuranceApi +
        formData[1]?.["insurance_id_" + newRowIndex] +
        "/",
        payload,
      );
    } else {
      res = await postDataFromApi(createPOInsuranceApi, payload);
    }
    if (res.data.status === 200) {
      getAllPOInsuranceListByPRDIDData(
        formData[0]?.prd_id,
        setTableData,
        formData,
        setFormData,
        section,
      );
      setPopupOpenAssignment(false);
      setPopupIndex("");
      setEditableIndex("");
      setIsBtnClicked(false);
      setIsOverlayLoader(false);
      setIsCustomPopup(false);
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setIsBtnClicked(false);
      setIsOverlayLoader(false);
      setIsCustomPopup(false);
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setSaveClicked(false);
    setIsOverlayLoader(false);
  } else if (actionSelected === "Delete") {
    setSaveClicked(true);
    setIsOverlayLoader(true);
    let res = await deleteDataFromApi(
      deletePOInsuranceApi + tableData[popupIndex]?.insurance_id + "/",
    );
    if (res?.status === 200) {
      getAllPOInsuranceListByPRDIDData(
        formData[0]?.prd_id,
        setTableData,
        formData,
        setFormData,
        section,
      );
      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsOverlayLoader(false);
    setSaveClicked(false);
    // setPopupOpenAssignment(false)
  } else if (actionSelected === "Cancel") {
    setEditableIndex("");
  }
};

export const getAllPOInsuranceListByPRDIDData = async (
  PRDID,
  setTableData,
  formData,
  setFormData,
  section,
) => {
  try {
    let res = await getDataFromApi(getPOInsuranceBYPRDIDApi + PRDID + "/");
    if (res?.data?.status === 200 && res.data.data) {
      const responseData = res.data.data;
      let updatedFormData = { ...formData };
      if (!updatedFormData) {
        updatedFormData = { ...formData };
      }
      let i = 0;
      const fieldMapping = {
        ins_range: "range_spec",
        ins_model: "model_name",
        ins_Instrument_sr_no: "instrument_sr_no",
        ins_make: "make",
        tax_invoice_amount: "tax_invoice_amount",
        ins_remark: "remark",
        ins_burglary: "burglary_insurance",
        ins_fire: "fire_insurance",
        ins_power_source: "power_source",
      };
      const actualResponseData = responseData.filter((singleInwardData) => {
        if (!updatedFormData[1]) {
          updatedFormData[1] = {};
        }
        section.rows.forEach((row) => {
          row.forEach((columnName) => {
            const mapKey = fieldMapping[columnName.name] || columnName.name;
            const formKey = `${columnName.name}_${i}`; // no extra "_"
            updatedFormData[1][formKey] = singleInwardData[mapKey] ?? "";
          });
        });
        updatedFormData[1]["insurance_is_burglary_" + i] = singleInwardData[
          "insurance_is_burglary"
        ]
          ? "Burglary"
          : "Fire";
        updatedFormData[1]["insurance_id_" + i] =
          singleInwardData["insurance_id"];
        i++;
        return true;
      });
      if (responseData.length > 0) {
        let singleInwardData = responseData[responseData.length - 1]
        let i = responseData.length
        section.rows.forEach((row) => {
          row.forEach((columnName) => {
            // if (!['instrument_sr_no'].includes(columnName.name)) {
            const mapKey = fieldMapping[columnName.name] || columnName.name;
            const formKey = `${columnName.name}_${i}`; // no extra "_"
            updatedFormData[1][formKey] = singleInwardData[mapKey] ?? "";
            // }

          });
        });
        updatedFormData[1]["insurance_is_burglary_" + i] = singleInwardData[
          "insurance_is_burglary"
        ]
          ? "Burglary"
          : "Fire";
        updatedFormData[1]["insurance_id_" + i] =
          singleInwardData["insurance_id"];
      }
      setFormData(updatedFormData);
      setTableData(actualResponseData);
    }
  } catch (error) {
    console.error(error);
  }
};

export const handlePOCreatByItems = async (
  formData,
  setIsOverlayLoader,
  getAllListingData,
  setIsViewOpen,
  selectedRow,
) => {
  try {
    if (formData?.po_prd_items.length === 0) {
      toast.error("Please choose at least one item to create PO", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    setIsOverlayLoader(true);
    let res;
    formData.isChangeCreatedBy = true
    // return
    if (
      formData?.po_prd_items.length ===
      selectedRow.items.filter((item) => !item.fk_po_id)?.length
    ) {
      if (selectedRow.items.filter((item) => item.fk_po_id == (selectedRow.po_id || selectedRow.first_po_id))?.length > 0) {
        res = await postDataFromApi(purchaseOrderCreateApi, formData);
      }
      else {
        const updateApi = purchaseOrderUpdateApi(selectedRow.po_id || selectedRow.first_po_id);
        res = await postDataFromApi(updateApi, formData);
      }
    } else {
      res = await postDataFromApi(purchaseOrderCreateApi, formData);
    }
    if (res?.data?.status === 200) {
      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      getAllListingData();
      setIsViewOpen(false);
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } catch (ex) {
  } finally {
    setIsOverlayLoader(false);
  }
};